import { TableRow, TableHead } from '@material-ui/core';
import { StyledTableCell } from './Style';
import { useStyles } from './Style';
import HelpIcon from '@material-ui/icons/Help';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';

export const ItemTableHead: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <TableHead>
        <TableRow>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            明細
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            階層
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            名称
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            仕様
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className={classes.subTableHead}>数量</div>
            <div className={classes.subTableHead}>（原価数量）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className='help-position'>
              <div className={classes.subTableHead}>単位</div>
              <CustomTooltip title={tooltipContents.itemUnit} placement='right'>
                <HelpIcon style={{ marginLeft: 8 }} />
              </CustomTooltip>
            </div>
            <div className={classes.subTableHead}>（原価単位）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className={classes.subTableHead}>単価</div>
            <div className={classes.subTableHead}>（原価単価）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className={classes.subTableHead}>定価金額</div>
            <div className={classes.subTableHead}>（原価金額）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            粗利
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            粗利率
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className="help-position">
            <div className={classes.subTableHead}>備考</div>
            <CustomTooltip
                    title={tooltipContents.author_memo}
                    placement="right">
                  <HelpIcon
                    style={{ marginLeft:8}}/>
              </CustomTooltip >
              </div>
            <div className={classes.subTableHead}>（社内用メモ）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            削除
          </StyledTableCell>
        </TableRow>
      </TableHead>
    </>
  );
};
